import { useState } from "react";
import PageBanner from "@/components/base/PageBanner";
import JsonLd from "@/components/base/JsonLd";
import { faqList } from "@/mocks/manga";

export default function FaqPage() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqList.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "首页", item: "https://897kg.cc/" },
      { "@type": "ListItem", position: 2, name: "常见问题", item: "https://897kg.cc/faq" },
    ],
  };

  return (
    <>
      <JsonLd id="jsonld-faq-page" data={faqSchema} />
      <JsonLd id="jsonld-breadcrumb-faq" data={breadcrumbSchema} />

      <PageBanner
        eyebrow="追更答疑"
        title="常见问题"
        desc="关于66漫画网更新动态、最新话、今天更新、补更与断更的常见疑问，这里都有详细解答。"
        crumbs={[{ label: "首页", to: "/" }, { label: "常见问题" }]}
      />

      <section className="mx-auto max-w-3xl px-4 py-10 md:px-6 md:py-14">
        <div className="flex flex-col gap-3">
          {faqList.map((item, i) => {
            const open = openIndex === i;
            return (
              <div
                key={item.q}
                className="overflow-hidden rounded-xl border border-background-200 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : i)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="text-sm font-bold text-foreground-900 md:text-base">{item.q}</span>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-700 transition-transform duration-300 ${
                      open ? "rotate-45" : ""
                    }`}
                  >
                    <i className="ri-add-line"></i>
                  </span>
                </button>
                {open && (
                  <div className="border-t border-background-200 px-5 py-4">
                    <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="mt-8 rounded-xl bg-background-100 p-6 text-center">
          <p className="text-sm text-foreground-700">还有其它问题？</p>
          <p className="mt-1 text-xs text-foreground-500">欢迎通过邮箱与我们联系，我们会尽快回复。</p>
          <a
            href="mailto:hello@66mangawang.com"
            className="mt-3 inline-flex items-center gap-2 rounded-full bg-primary-500 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-mail-line"></i>
            联系客服
          </a>
        </div>
      </section>
    </>
  );
}